import { INavigationLink } from "@faire/retailer-visitor-shared/components/Header/desktop/NavigationLinksBar/__internal__/INavigationLink";
import { INavigationLink as INavigationLinkData } from "@faire/web-api--source/indigofair/data/INavigationLink";
import { INavigationLinkGroup } from "@faire/web-api--source/indigofair/data/INavigationLinkGroup";
import { IQueryFlashSalesRequest } from "@faire/web-api--source/indigofair/data/IQueryFlashSalesRequest";

import { IL1NavigationLink } from "./ILNavigationLink";
import { mapNavigationLinkToL1Link } from "./navigationLinkUtils";

export function getNavigationBarVisibleLinks(
  navigationLinkGroup: INavigationLinkGroup[]
): INavigationLink[] {
  return navigationLinkGroup
    .flatMap((group) => group.navigation_links)
    .filter(
      (link) =>
        link.style_group !== INavigationLinkData.StyleGroup.INVISIBLE &&
        link.style_group !==
          INavigationLinkData.StyleGroup.INVISIBLE_FOR_ASSIGNMENT
    )
    .map(
      ({
        name,
        deep_link_path,
        path_identifier,
        unique_identifier,
        sublinks,
        sale_source,
      }) => ({
        name: name ?? "",
        to: deep_link_path,
        hasSublinks: sublinks.length > 0,
        categoryPathIdentifier: path_identifier,
        uniqueIdentifier: unique_identifier,
        isWarehouseSale:
          sale_source === IQueryFlashSalesRequest.SearchSource.SEASONAL_SALE,
      })
    );
}

export function getNavigationBarDropdownLinks(
  navigationLinkGroup: INavigationLinkGroup[]
): IL1NavigationLink[] {
  const links: IL1NavigationLink[] = navigationLinkGroup
    .flatMap((group) => {
      return group.navigation_links.map((link) => ({
        ...link,
        groupUniqueIdentifier: group.unique_identifier,
      }));
    })
    .filter(
      (link) =>
        link.sublinks.length > 0 &&
        link.style_group !== INavigationLinkData.StyleGroup.INVISIBLE &&
        link.style_group !==
          INavigationLinkData.StyleGroup.INVISIBLE_FOR_ASSIGNMENT
    )
    .map((navigationLink) => mapNavigationLinkToL1Link(navigationLink));

  return links;
}
